module.exports = __webpack_public_path__ + "static/media/stethoscope.d906fa51.svg";